import { FC } from "react";
import { Button } from "@/components/Button/Button";
import { Image } from "@/components/Image/Image";
import { Link } from "@/components/Link/Link";
import { pagesPath } from "@/lib/$path";

export const InfoCard: FC = () => {
  return (
    <div className="mt-[16px] w-auto overflow-hidden rounded-[8px] border border-l-[5px] border-solid border-gray-pale border-l-primary bg-white">
      <div className="flex flex-col gap-[16px] p-[20px]">
        <div className="flex items-center gap-[4px]">
          <Image
            width={24}
            height={24}
            src={"/images/info-outline.svg"}
            alt="info-outline"
            className="h-[24px] w-[24px]"
          />
          <p>お知らせ</p>
        </div>

        <p>
          K.DEVは株式会社KDOTにより運営されています。記事の内容や会社でのITに関わる一般的なご相談に専門の社員がお答えしております。ぜひお気軽にご連絡ください。
        </p>

        <div className="flex items-center justify-center">
          <Link href={pagesPath.inquiry.$url()} target="_blank">
            <Button>
              <span className="block md:inline-block">お問合せ・相談受付フォーム</span>
              <span className="block md:inline-block">（会社ホームページが開きます）</span>
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};
